export const MINIMAL_HTML_SCAFFOLD = `<!doctype html>
<html>
  <head>
    <meta charset="utf-8">
  </head>
  <body>
    <p></p>
  </body>
</html>`;
